import { createRouter, createWebHistory } from 'vue-router'
import routes from '@/routes'
import feature from '@/middleware/router/feature'
import refetch from '@/middleware/router/refetch'
import amplify from '@/middleware/router/amplify'
import freeBreeze from '@/middleware/router/freeBreeze'

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach(async (to, from, next) => {
    await refetch(to)
    next()
})
router.beforeEach(feature)
router.beforeEach(amplify)
router.beforeEach(freeBreeze)

export default router
